export default __webpack_public_path__ + "static/media/settings.4a5ab6b1.webp";